<template>
  <el-pagination
    style="margin-top: 10px"
    :current-page="currentPage"
    :page-size="pageSize"
    :page-sizes="[10,20, 50, 100,200]"
    :total="total"
    background
    layout="total, sizes, prev, pager, next, jumper"
    @current-change="onChangeCurrent"
    @size-change="onChangeSize"
  />
</template>

<script>
export default {
  name: 'TablePagination',
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {}
  },
  methods: {
    onChangeCurrent(page) {
      this.$emit('current-change', page)
    },
    onChangeSize(size) {
      this.$emit('size-change', size)
    }
  }
}
</script>

<style scoped>

</style>
